import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import httpService from "../../../Service/httpService";
import StripeEmbedPaymentForm from "../Components/StripeEmbedPaymentForm";
import { CircularProgress } from "@mui/material";
import { getUserID } from "../../../Service/getLocalStorage";

interface BuyGiftCardProps {
  type: string;
  id: string;
  yourName: string;
  yourEmail: string;
  giftTargetName: string;
  giftTargetEmail: string;
  price: string;
  isAuthorized: boolean;
}

const BuyGiftCard = ({
  type,
  id,
  yourName,
  yourEmail,
  giftTargetName,
  giftTargetEmail,
  price,
  isAuthorized,
}: BuyGiftCardProps) => {
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    const getClientSecret = async () => {
      try {
        const response: { data: { clientSecret: string } } =
          await httpService.post("gift/new-payment", {
            user_id: getUserID(),
            type,
            id,
            yourName,
            yourEmail,
            giftTargetName,
            giftTargetEmail,
            price,
            qty: 1,
          });

        setClientSecret(response.data.clientSecret);

        return;
      } catch (err: any) {
        toast.error(err?.message);
      }
    };

    getClientSecret();
  }, [giftTargetEmail, giftTargetName, id, price, type, yourEmail, yourName]);

  return (
    <div>
      {clientSecret && <StripeEmbedPaymentForm clientSecret={clientSecret} />}
      {!clientSecret && (
        <div className="w-full d-flex align-items-center justify-content-center py-5">
          <CircularProgress />
        </div>
      )}
    </div>
  );
};

// if (isAuthorized) {
//   posthog.capture("user-purchases-a-gift-card", {
//     type,
//     id,
//     price,
//     userId: getUserID(),
//   });

//   grinEvent({
//     amount: price,
//     order_number: `${res?.data?.transaction_id}`,
//   });
// }

export default BuyGiftCard;
